import Select from 'react-select'
import React, { useState } from 'react'
import { AiOutlineDown } from 'react-icons/ai'

import { usePet, useToggle, notifOps, normalizeCase } from '../../modules'

import { roles } from '../../permissions'
import { Drawer, Dropdown, Menu } from 'antd'
import ReportParams from './reportParams'
import Confirm from '../reusable/confirm'

const NewReportTemplate = ({ toggle, visible, departments, onPerform }) => {
    const [name, setName] = useState()
    const [index, setIndex] = useState()
    const [selected, setSelected] = useState()
    const [endpoint, setEndpoint] = useState()
    const [printTemplate, setPrintTemplate] = useState()
    const [outputTypes, setOutput] = useState([])
    const [department, setDepartment] = useState()
    const [description, setDescription] = useState()
    const [parameters, setParameters] = useState([])
    
    const [params, toggleParams] = useToggle()

    const close = () => {
        toggle()
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Report template has been added', ops('success'))
        
        setTimeout(close, 300)
    }

    const editParams = i => {
        setSelected(parameters[i])
        setIndex(i)
        toggleParams()
    }

    let output = ['Graphic', 'Excel', 'PDF']
    
    const [{ loading }, execute] = usePet('newReportTemplate', {
        name,
        endpoint,
        department: department?.value,
        printTemplate: printTemplate?.value,
        description,
        outputTypes: outputTypes?.map(typ => typ?.label),
        parameters: parameters.map(({ name, type, source, labelProperty, valueProperty, options = [], endpoint, payload }) => ({
            name, 
            type: type?.label, 
            source: source?.label, 
            labelProperty, 
            valueProperty,
            endpoint, 
            options: options.map(({ label }) => label),
            payload
        }))
    }, { notify: true, callback: onComplete, manual: true })

    const onSave = ({ params, i }) => {
        setParameters(val => {
            if (i >= 0)
                val[i] = params
            else
                val = [...val, params]
            
            return val
        })
    }

    const clearSelected = () => {
        setSelected()
        setIndex()
    }

    const remove = index => {
        clearSelected()
        setParameters(val => val.filter((_, i) => i !== index))
    }

    const newParams = () => {
        clearSelected()
        toggleParams()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={ () => Confirm({
                        title: 'Create Template',
                        message: 'Are you sure you want to create this template?',
                        onOk: execute,
                        okText: 'Proceed',
                    }) } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Create Template</button>
                </div>
            }
            width="30%">
            <p className="font-extrabold text-3xl mb-0">New Report Template</p>
            <div>
                <div className="flex flex-wrap mt-3 -mx-3">
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Report Name
                        </label>
                        <input 
                            onChange={ e => setName(e.target.value) }
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                            id="grid-role-name" 
                            type="text" 
                            value={ name }
                            name="name"
                            placeholder="Daily Visits" />
                    </div>
                </div>
                <div className="flex flex-wrap mt-3 -mx-3">
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Report Endpoint
                        </label>
                        <input 
                            onChange={ e => setEndpoint(e.target.value) }
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                            id="grid-endpoint" 
                            type="text" 
                            value={ endpoint }
                            name="name"
                            placeholder="patients" />
                    </div>
                </div>
                <div className="flex flex-wrap mt-1 -mx-3">                  
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Output Types
                        </label>
                        <Select
                            isMulti
                            value={ outputTypes }
                            onChange={ setOutput }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ output?.map(typ => ({ label: typ, value: typ }))  }
                            placeholder="Select Types" />
                    </div>
                </div>
                {
                    outputTypes?.some(typ => typ?.label === 'PDF') &&
                    <div className="flex flex-wrap mt-3 -mx-3">
                        <div className="w-full px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Printout Template
                            </label>
                            <input 
                                onChange={ e => setPrintTemplate(e.target.value) }
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                id="grid-print" 
                                type="text" 
                                value={ printTemplate }
                                name="print"
                                placeholder="printout-template" />
                        </div>
                    </div>
                }
                <div className="flex flex-wrap mt-3 -mx-3">                  
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Department
                        </label>
                        <Select
                            isClearable
                            value={ department }
                            onChange={ setDepartment }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ departments?.map(dept => ({ label: normalizeCase(dept?.replace('-', ' ')), value: dept }))  }
                            placeholder="Select Department" />
                    </div>
                </div>
                <div className="flex flex-wrap mt-3 -mx-3">                  
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Description
                        </label>
                        <textarea 
                            rows="4"
                            onChange={ e => setDescription(e.target.value) }
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                            id="grid-department" 
                            type="text" 
                            value={ description }
                            name="description"
                            placeholder="Description" />
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-between">
                <p className="font-bold my-3">Parameters</p>
            </div>
            <br />
            {
                parameters?.length > 0 ?
                    <>
                        <table className="table-auto w-full">
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">No</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Name</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Type</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center"></div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    parameters.map((params, key) =>
                                        <tr>
                                            <td className="p-2">
                                                <div className="text-center">{key + 1}.</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="">{ params.name }</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="">{ params.type?.label }</div>
                                            </td>
                                            <td className="p-2">
                                                <div>
                                                    <Dropdown
                                                        overlay={
                                                            <Menu>
                                                                <Menu.Item onClick={ () => editParams(key) }>View</Menu.Item>
                                                                <Menu.Item onClick={ () => remove(key) }>Remove</Menu.Item>
                                                            </Menu>
                                                        }>
                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </>
                : 
                    <div className="w-full h-16 text-center">
                        <p className="font-semibold">Please click below to add new parameters</p>
                    </div>
            }
            {
                params && 
                <ReportParams 
                    index={ index } 
                    onSave={ onSave } 
                    visible={ params } 
                    params={ selected } 
                    toggle={ toggleParams } />
            }
            <div className="w-full h-16 text-center">
                <button onClick={ newParams } className="btn py-2 px-3 mt-0 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text">Add New Parameter</button>
            </div>
        </Drawer>
    )
}

export default NewReportTemplate